<template>
  <section class="content">
    <bulk-update-modal
      @alert="pushAlertMessage($event)"
      :productCount="filteredProductCount"
      :products="filteredProducts"
      :url="filterUrl"
      :filters="selectedFilters"
      :alert="alerts"
    >
    </bulk-update-modal>
    <template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type == 'success' || alert.type == 'warning'" class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{'alert_'+alert.type | translate}}!</h4>
        <p>
          {{alert.message}}
        </p>
      </b-alert>
    </template>
      <div class="row">
        <div class="col-xs-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">{{'manage_products' | translate}}</h3>
              <br>
              <small class="text-bold">
                {{ pagination.from }} - {{ pagination.to }} von {{ pagination.total }} {{ 'products' | translate }}
                {{ 'filter_text' | translate }}
              </small>
            </div>
            <div class="box-controls">
              <div class="btn-group">
                <button
                  type="button"
                  data-toggle="collapse"
                  data-target="#coll1"
                  aria-expanded="true"
                  aria-controls="coll1"
                  class="btn btn-default btn-sm"
                >
                <i class="fa fa-sort mr-5"></i>{{'show_hide_filters' | translate}}
              </button>
            </div>
            <div class="row pt-10">
              <div class="col-xs-12">
                <ResultPerSideBar @page-changed="paginateFilters"></ResultPerSideBar>
                <my-pagination :total="pagination.total" :per-page="pagination.per_page"
                               :pagination="pagination"></my-pagination>
              </div>
            </div>
              <div class="row">
                <div class="col-xs-12">
                  <div id="coll1" class="collapse in" aria-expanded="true" style="">
                    <div class="pt-10 row">
                      <div class="col-md-3 col-sm-6">
                        <div class="input-group">
                          <input
                            @keyup.13.prevent="paginate"
                            @blur=paginate type="text"
                            name="search" :placeholder="'search_brand' | translate"
                            class="form-control"
                            v-model="filters.brand"
                          >
                          <div class="input-group-btn">
                            <button type="submit" name="submit" class="btn">
                              <i class="fa fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <input
                          @keyup.13.prevent="paginate"
                          @blur=paginate
                          type="text"
                          name="search"
                          :placeholder="'search_erp_id' | translate"
                          class="form-control"
                          v-model="filters.wws_number"
                        >
                        <div class="input-group-btn">
                          <button type="submit" name="submit" class="btn">
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <input
                          @keyup.13.prevent="paginate"
                          @blur=paginate
                          type="text"
                          name="search"
                          :placeholder="'search_erp_number' | translate"
                          class="form-control"
                          v-model="filters.wws_model"
                        >
                        <div class="input-group-btn">
                          <button type="submit" name="submit" class="btn">
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <input
                          :disabled="filterNoImage"
                          @keyup.13.prevent="paginate"
                          @blur=paginate
                          type="text"
                          name="search"
                          :placeholder="'search_image' | translate"
                          class="form-control"
                          v-model="filters.img_id"
                        >
                        <div class="input-group-btn">
                          <button type="submit" name="submit" class="btn">
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pt-10 row">
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">
                          {{'return_rate' | translate}}<i class="fa fa-caret-up ml-5"></i>
                        </div>
                        <select class="form-control" v-model="filters.return_rate_bigger" @change="paginate">
                          <option class="normal" value="0">{{'all' | translate}}</option>
                          <option class="normal" value="10">{{'greater_than' | translate}} 10%</option>
                          <option class="normal" value="20">{{'greater_than' | translate}} 20%</option>
                          <option class="normal" value="30">{{'greater_than' | translate}} 30%</option>
                          <option class="normal" value="40">{{'greater_than' | translate}} 40%</option>
                          <option class="normal" value="50">{{'greater_than' | translate}} 50%</option>
                          <option class="normal" value="60">{{'greater_than' | translate}} 60%</option>
                          <option class="normal" value="70">{{'greater_than' | translate}} 70%</option>
                          <option class="normal" value="80">{{'greater_than' | translate}} 80%</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">
                          {{'return_rate' | translate}}<i class="fa fa-caret-down ml-5"></i>
                        </div>
                        <select class="form-control" v-model="filters.return_rate_lower" @change="paginate">
                          <option class="normal" value="0">{{'all' | translate}}</option>
                          <option class="normal" value="10">{{'smaller_than' | translate}} 10%</option>
                          <option class="normal" value="20">{{'smaller_than' | translate}} 20%</option>
                          <option class="normal" value="30">{{'smaller_than' | translate}} 30%</option>
                          <option class="normal" value="40">{{'smaller_than' | translate}} 40%</option>
                          <option class="normal" value="50">{{'smaller_than' | translate}} 50%</option>
                          <option class="normal" value="60">{{'smaller_than' | translate}} 60%</option>
                          <option class="normal" value="70">{{'smaller_than' | translate}} 70%</option>
                          <option class="normal" value="80">{{'smaller_than' | translate}} 80%</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">
                          {{'price_rate' | translate}}<i class="fa fa-caret-up ml-5"></i>
                        </div>
                        <input
                          @blur="paginate"
                          type="number"
                          name="search"
                          class="form-control"
                          v-model="filters.products_price_bigger"
                        >
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">
                          {{'price_rate' | translate}}<i class="fa fa-caret-down ml-5"></i>
                        </div>
                        <input
                          @blur="paginate"
                          type="number"
                          name="search"
                          class="form-control"
                          v-model="filters.products_price_lower"
                        >
                      </div>
                    </div>
                  </div>
                  <div class="pt-10 row">
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">
                          {{'total_sales_f' | translate}}<i class="fa fa-caret-up ml-5"></i>
                        </div>
                        <input
                          @keyup.13.prevent="paginate"
                          @blur="paginate"
                          type="number"
                          name="search"
                          class="form-control"
                          v-model="filters.total_sales_bigger"
                        >
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">
                          {{'total_sales_f' | translate}}<i class="fa fa-caret-down ml-5"></i>
                        </div>
                        <input
                          @keyup.13.prevent="paginate"
                          @blur="paginate"
                          type="number"
                          name="search"
                          class="form-control"
                          v-model="filters.total_sales_lower"
                        >
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">
                          {{'stock_company' | translate}}<i class="fa fa-caret-up ml-5"></i>
                        </div>
                        <input
                          @keyup.13.prevent="paginate"
                          @blur="paginate"
                          type="number"
                          name="search"
                          class="form-control"
                          v-model="filters.stock_company_bigger"
                        >
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">
                          {{'stock_company' | translate}}<i class="fa fa-caret-down ml-5"></i>
                        </div>
                        <input
                          @keyup.13.prevent="paginate"
                          @blur="paginate"
                          type="number"
                          name="search"
                          class="form-control"
                          v-model="filters.stock_company_lower"
                        >
                      </div>
                    </div>
                  </div>
                  <div class="pt-10 row">
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">{{'status' | translate}}</div>
                        <multiselect
                          v-model="filters.marketplaces"
                          :options="mps"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :hide-selected="true"
                          :placeholder="'select_multiple' | translate"
                          label="name"
                          track-by="status"
                          @input="paginate()"
                          :multiple="true"
                        >
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">{{'season' | translate}}</div>
                        <multiselect
                          v-model="filters.seasons"
                          :options="multiselectSeasons"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :hide-selected="true"
                          :placeholder="'select_multiple' | translate"
                          @input="paginate()"
                          :multiple="true"
                        >
                        </multiselect>
                        <div class="input-group-btn">
                          <button type="submit" name="submit" class="btn">
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <span class="mr-5">
                          {{'no_image' | translate}}
                          <input type="checkbox" v-model="filterNoImage" @change="paginate('', '')">
                        </span>
                      <div class="btn-group">
                        <b-btn
                          @click="clear"
                          type="button"
                          class="btn btn-sm btn-warning mr-5"
                        >
                          <i class="fa fa-undo mr-5"></i>{{'reset_filters' | translate}}
                        </b-btn>
                        <b-btn
                          v-if="filterSet"
                          type="button"
                          class="btn btn-sm btn-danger"
                          data-toggle="modal"
                          data-target="#bulk-update-modal"
                          aria-expanded="false"
                          aria-controls="alertModal"
                        >
                          <i class="fa fa-cog mr-5"></i>
                          {{'bulk_update' | translate}}
                        </b-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-5">
                <h5 class="csv-download-header">
                  {{'csv_download' | translate}}
                </h5>
                <div class="input-group">
                  <div class="input-group-addon">
                    <span>{{'filename' | translate}}</span>
                  </div>
                  <input
                    type="text"
                    name="fileNameAddition"
                    :placeholder="'insert_filename' | translate"
                    class="form-control"
                    v-model="fileNameAddition"
                  >
                  <div class="input-group-btn">
                    <b-btn
                      @click="createCsv"
                      type="button"
                      :disabled="loadingCsv"
                      class="btn btn-default"
                    >
                      <i :class="[loadingCsv ? 'fa fa-spinner fa-spin' : 'fa fa-upload', 'mr-5']"></i>
                      {{'create_csv' | translate}}
                    </b-btn>
                  </div>
                  <div class="input-group-btn" v-if="toggleButton">
                    <b-btn
                      @click="downloadCsv"
                      type="button"
                      class="btn btn-success"
                    >
                      <i :class="[loadingCsv ? 'fa fa-spinner fa-spin' : 'fa fa-cloud-download', 'mr-5']"></i>
                      {{'download' | translate}}
                    </b-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-body">
            <template v-if="loading">
              <div class="row">
                <div class="col-xs-12 text-center">
                  <img class="loading-gif" src="/static/img/blabla.svg"/>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                  <tr>
                    <th>{{'image' | translate}}</th>
                    <th>{{'model' | translate}}</th>
                    <th style="width:12%;" class="is-clickable">
                      <i :class="[filters.sort_price_rate === '' ? 'fa fa-sort' : `fa fa-sort-${filters.sort_price_rate}`, 'mr-5']"></i>
                      {{'prices' | translate}}
                    </th>
                    <th style="width:9%;">{{'sales' | translate}}</th>
                    <th style="width:9%;">{{'returns' | translate}}</th>
                    <th class="is-clickable" @click="getState('sort_return_rate', filters.sort_return_rate)">
                      <i :class="[filters.sort_return_rate === '' ? 'fa fa-sort' : `fa fa-sort-${filters.sort_return_rate}`, 'mr-5']"></i>
                      {{'return_rate' | translate}}
                    </th>
                    <th class="is-clickable" @click="getState('sort_stock_company', filters.sort_stock_company)">
                      <i :class="[filters.sort_stock_company === '' ? 'fa fa-sort' : `fa fa-sort-${filters.sort_stock_company}`, 'mr-5']"></i>
                      {{'stock_company' | translate}}
                    </th>
                    <th class="is-clickable" @click="getState('sort_products_price', filters.sort_products_price)">
                      <i :class="[filters.sort_products_price === '' ? 'fa fa-sort' : `fa fa-sort-${filters.sort_products_price}`, 'mr-5']"></i>
                      {{'price' | translate}}
                    </th>
                    <th style="width:16%;">{{'status' | translate}}</th>
                    <th>{{'edit' | translate}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="item in pagination.data">
                    <tr>
                      <td>
                        <router-link :to="`/products/${item.wws_model}`">
                          <img :src="item.img_path" class="img-preview">
                        </router-link>
                      </td>
                      <td style="width:20%;">
                        <strong>{{item.title}}</strong><br>
                        <small class="text-muted">{{'brand' | translate}}: {{item.brand}}</small><br>
                        <small class="text-muted">{{'image' | translate}} ID: {{item.img_id}}</small><br>
                        <small class="text-muted">{{'erp_id' | translate}}: {{item.wws_number}}</small><br>
                        <small class="text-muted">{{'erp_number' | translate}}: {{item.wws_model}}</small><br/>
                        <small class="text-muted">{{'season' | translate}}: {{item.season}}</small>
                      </td>
                      <td>
                        <ul class="list-unstyled small" v-if="typeof item.prices !== 'undefined'">
                          <li v-for="mp in getChannels(item.prices)"><i :class="['fa', getIcon(mp.name), 'mr-5']"></i>
                            {{mp.name | translate}}: Ø {{mp.value | currency}}
                          </li>
                        </ul>
                        <strong class="text-muted">Ø-{{'price' | translate}}: {{item.price_rate | currency}}</strong>
                      </td>
                      <td>
                        <ul class="list-unstyled small" v-if="typeof item.sales !== 'undefined'">
                          <li v-for="mp in getChannels(item.sales)"><i :class="['fa', getIcon(mp.name), 'mr-5']"></i>
                            {{mp.name | translate}}: {{mp.value}}
                          </li>
                        </ul>
                        <strong class="text-muted">{{'amount' | translate}}: {{item.sales.total}}</strong>
                      </td>
                      <td>
                        <ul  v-if="typeof item.returns !== 'undefined'" class="list-unstyled small">
                          <li v-for="mp in getChannels(item.returns)"><i :class="['fa', getIcon(mp.name), 'mr-5']"></i>
                            {{mp.name | translate}}: {{mp.value}}
                          </li>
                        </ul>
                        <strong class="text-muted">{{'amount' | translate}}: {{item.returns.total}}</strong>
                      </td>
                      <td>
                        <p>
                          <strong :class="'text-' + item.pct.style">
                            <i :class="item.pct.icon"></i>{{item.pct.val| currency('%')}}
                          </strong>
                        </p>
                        <div class="progress xs no-margin">
                          <div :class="`progress-bar progress-bar-${item.pct.style}`" :style="`width: ${item.pct.val}%`"></div>
                        </div>
                      </td>
                      <td>
                        {{item.stock_company}}
                      </td>
                      <td>
                        {{item.products_price | currency}}
                      </td>
                      <td>
                        <template v-for="channel in item.channels">
                          <product-channel
                            :channel="channel"
                            :model="item.wws_model"
                            :key="`${item.id}-${channel.name}`"
                            @pushAlert="toggleChannel($event, item)"
                          >
                          </product-channel>
                        </template>
                      </td>
                      <td>
                        <router-link :to="`/productmanagement/products/${item.wws_model}`" target="_blank" rel="opener">
                          <b-btn class="btn btn-app no-margin btn-info">
                            <i class="fa fa-edit"></i>{{'details' | translate}}
                          </b-btn>
                        </router-link>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </template>
          </div>
          <div class="box-footer">
            <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import VueMultiselect from 'vue-multiselect/src/Multiselect'
export default {
  name: 'Statistics',
  components: {VueMultiselect},
  data () {
    return {
      sortReturnRate: '',
      sortPriceRate: '',
      filterNoImage: false,
      loadingCsv: false,
      mps: [
        { status: 'amazon', name: 'Amazon - active', amazon: true },
        { status: 'amazon', name: 'Amazon - inactive', amazon: false },
        { status: 'ebay', name: 'eBay - active', ebay: true },
        { status: 'ebay', name: 'eBay - inactive', ebay: false },
        { status: 'zalando', name: 'Zalando - active', zalando: true },
        { status: 'zalando', name: 'Zalando - inactive', zalando: false },
        { status: 'spartoo', name: 'Spartoo - active', spartoo: true },
        { status: 'spartoo', name: 'Spartoo - inactive', spartoo: false },
        { status: 'mirapodo', name: 'Mirapodo - active', mirapodo: true },
        { status: 'mirapodo', name: 'Mirapodo - inactive', mirapodo: false },
        { status: 'tamaris', name: 'Tamaris - active', tamaris: true },
        { status: 'tamaris', name: 'Tamaris - inactive', tamaris: false },
        { status: 'check24', name: 'Check24 - active', check24: true },
        { status: 'check24', name: 'Check24 - inactive', check24: false },
        { status: 'legero', name: 'Legero - active', legero: true },
        { status: 'legero', name: 'Legero - inactive', legero: false },
        { status: 'gaxsys', name: 'Gaxsys - active', gaxsys: true },
        { status: 'gaxsys', name: 'Gaxsys - inactive', gaxsys: false },
        { status: 'goertz', name: 'Goertz - active', goertz: true },
        { status: 'goertz', name: 'Goertz - inactive', goertz: false },
        { status: 'marco_tozzi', name: 'Marco Tozzi - active', marco_tozzi: true },
        { status: 'marco_tozzi', name: 'Marco Tozzi - inactive', marco_tozzi: false },
        { status: 'sport2000', name: 'Sport2000 - active', sport2000: true },
        { status: 'sport2000', name: 'Sport2000 - inactive', sport2000: false },
        { status: 'gabor', name: 'Gabor - active', gabor: true },
        { status: 'gabor', name: 'Gabor - inactive', gabor: false },
        { status: 'caprice', name: 'Caprice - active', caprice: true },
        { status: 'caprice', name: 'Caprice - inactive', caprice: false },
        { status: 'limango_de', name: 'Limango.de - active', limango_de: true },
        { status: 'limango_de', name: 'Limango.de - inactive', limango_de: false },
        { status: 'kaufland_de', name: 'Kaufland.de - active', kaufland_de: true },
        { status: 'kaufland_de', name: 'Kaufland.de - inactive', kaufland_de: false }
      ],
      filters: {
        wws_model: '',
        wws_number: '',
        img_id: '',
        brand: '',
        return_rate_bigger: 0,
        return_rate_lower: 0,
        products_price_bigger: '',
        products_price_lower: '',
        total_sales_bigger: '',
        total_sales_lower: '',
        marketplaces: [],
        sort_return_rate: '',
        sort_products_price: '',
        sort_stock_company: '',
        stock_company_bigger: 1,
        stock_company_lower: 0,
        seasons: []
      },
      fileNameAddition: '',
      multiselectSeasons: [],
      alerts: [],
      selectedErpNumber: '',
      selectedSku: '',
      rateBigger: 0,
      rateSmaller: 0,
      paginationPerPageChild:0,
      pagination: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0
      },
      filtersApplied: 0,
      filteredProductCount: 0,
      filterUrl: '',
      selectedFilters: '',
      filteredProducts: {},
      loading: false,
      filterSet: false,
      toggleButton: false
    }
  },
  computed: {
  },
  methods: {
    getState (obj, state) {
      if (state === '') {
        state = 'asc'
      } else if (state === 'asc') {
        state = 'desc'
      } else {
        state = ''
      }
      this.filters[obj] = state
      this.paginate('sort', '')
    },
    loadFilters() {
      API.get('inventory/filters')
        .then(response => {
          this.multiselectSeasons = response.data.season
        })
        .catch(error => {
          this.$store.dispatch('checkError', error)
          this.loading = false
        })
    },
    paginateFilters(perPage){
      this.paginationPerPageChild = perPage
      this.paginate('page','', perPage)
    },
    paginate(type, value) {
      this.pagination.per_page = this.paginationPerPageChild
      let url = `?count=${this.pagination.per_page}&`
      let fs = Object.keys(this.filters)
      fs.forEach(f => {
        if (f !== 'img_id') {
          if (f === 'marketplaces') {
            let channels = {}
            this.filters[f].forEach(mp => {
              channels[mp.status] = mp[mp.status]
            })
            url += `channels=${JSON.stringify(channels)}&`
          } else if (f === 'seasons') {
            url += `seasons=${JSON.stringify(this.filters.seasons)}&`
          } else {
            url += `${f}=${this.filters[f]}&`
          }
        }
      })
      url += `img_id=${this.filterNoImage ? 0 : this.filters.img_id}`
      if (type === 'page') {
        url += '&page='
        if (value === 'previous') {
          url += (this.pagination.current_page - 1)
        }
        if (value === 'next') {
          url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
        } else if (value !== 'next' && value !== 'previous') {
          url += value
        }
      }
      url = url.replace(/&+$/, '')
      this.filterUrl = url
      this.selectedFilters = url.split('?')[1].split('&')
      this.loading = true
      this.prepareFilters()
      API.get(`inventory${url}`)
        .then(response => {
          this.pagination = response.data
          this.filteredProducts = Object.assign({}, this.pagination.data)
          this.filteredProductCount = this.pagination.total
          this.pagination.data.forEach(i => {
            let total = i.return_rate
            i.pct = {
              style: total <= 40 ? 'success' : total >= 80 ? 'danger' : 'warning',
              icon: total <= 40 ? 'fa fa-check mr-5' : total >= 80 ? 'fa fa-flash mr-5' : 'fa fa-warning mr-5',
              val: total
            }
            i.showChannels = true
          })
          this.loading = false
        })
        .catch(error => {
          this.$store.dispatch('checkError', error)
          this.loading = false
        })
    },
    prepareFilters () {
      if (this.selectedFilters !== '') {
        this.filterSet = false
        this.selectedFilters.forEach(filter => {
          let splitFilter = filter.split('=')
          if (splitFilter[0] === 'products_price_lower' || splitFilter[0] === 'products_price_bigger') {
            splitFilter[1] = splitFilter[1].replace(',', '.')
            this.filterSet = true
          }
          if (splitFilter[0] !== 'count' && splitFilter[0] !== 'stock_company_bigger') {
            if (parseInt(splitFilter[1]) > 0 && splitFilter[1] !== '') {
              this.filterSet = true
            } else if (splitFilter[0] === 'brand' && splitFilter[1] !== '') {
              this.filterSet = true
            } else if (splitFilter[0] === 'channels' && (splitFilter[1] !== '' && splitFilter[1] !== '{}')) {
              this.filterSet = true
            }
          }
        })
      }
    },
    clear () {
      this.filters = {
        wws_model: '',
        wws_number: '',
        img_id: '',
        marketplaces: [],
        brand: '',
        return_rate_bigger: 0,
        return_rate_lower: 0,
        products_price_bigger: 0,
        products_price_lower: 0,
        total_sales_bigger: 0,
        total_sales_lower: 0,
        sort_return_rate: '',
        sort_price_rate: '',
        sort_stock_company: '',
        stock_company_bigger: 1,
        stock_company_lower: 0,
        fileNameAddition: '',
        seasons: []
      }
      this.filterNoImage = false
      this.paginate('', '')
    },
    getIcon (mp) {
      return mp === 'schuhede' ? 'fa-schuhe' : `fa-${mp}`
    },
    getChannels (item) {
      return [
        {
          name: 'schuhede',
          value: typeof item.schuhede !== 'undefined' ? item.schuhede : 0
        },
        {
          name: 'selfservice_schuhede',
          value: typeof item.selfservice_schuhede !== 'undefined' ? item.selfservice_schuhede : 0
        },
        {
          name: 'zalando',
          value: typeof item.zalando !== 'undefined' ? item.zalando : 0
        },
        {
          name: 'amazon',
          value: typeof item.amazon !== 'undefined' ? item.amazon : 0
        },
        {
          name: 'ebay',
          value: typeof item.ebay !== 'undefined' ? item.ebay : 0
        },
        {
          name: 'spartoo',
          value: typeof item.spartoo !== 'undefined' ? item.spartoo : 0
        },
        {
          name: 'mirapodo',
          value: typeof item.mirapodo !== 'undefined' ? item.mirapodo : 0
        },
        {
          name: 'tamaris',
          value: typeof item.tamaris !== 'undefined' ? item.tamaris : 0
        },
        {
          name: 'check24',
          value: typeof item.check24 !== 'undefined' ? item.check24 : 0
        },
        {
          name: 'goertz',
          value: typeof item.goertz !== 'undefined' ? item.goertz : 0
        },
        {
          name: 'gaxsys',
          value: typeof item.gaxsys !== 'undefined' ? item.gaxsys : 0
        },
        {
          name: 'legero',
          value: typeof item.legero !== 'undefined' ? item.legero : 0
        },
        {
          name: 'marco_tozzi',
          value: typeof item.marco_tozzi !== 'undefined' ? item.marco_tozzi : 0
        },
        {
          name: 'sport2000',
          value: typeof item.sport2000 !== 'undefined' ? item.sport2000 : 0
        },
        {
          name: 'gabor',
          value: typeof item.gabor !== 'undefined' ? item.gabor : 0
        },
        {
          name: 'caprice',
          value: typeof item.caprice !== 'undefined' ? item.caprice : 0
        },
        {
          name: 'limango_de',
          value: typeof item.limango_de !== 'undefined' ? item.limango_de : 0
        },
        {
          name: 'kaufland_de',
          value: typeof item.kaufland_de !== 'undefined' ? item.kaufland_de : 0
        }
      ]
    },
    getData () {
      this.loading = true
      API.get(`inventory?stock_company_bigger=${this.filters.stock_company_bigger}`)
        .then(res => {
          this.pagination = res.data
          this.pagination.data.forEach(i => {
            let total = i.return_rate
            i.pct = {
              style: total <= 40 ? 'success' : total >= 80 ? 'danger' : 'warning',
              icon: total <= 40 ? 'fa fa-check mr-5' : total >= 80 ? 'fa fa-flash mr-5' : 'fa fa-warning mr-5',
              val: total
            }
            i.showChannels = true
            i.showSpinner = false
          })
          this.prepareFilters()
          this.loading = false
          this.loadFilters()
        })
        .catch(error => {
          console.log(error)
        })
    },
    getProduct (item) {
    },
    toggleChannel (value, item) {
      let tog = item.channels.find(x => x.name === value.channel)
      tog.active = value.active
    },
    pushAlertMessage (alert) {
      this.$store.commit('pushAlert', alert)
      this.loading = true
      API.get(`inventory${this.filterUrl}`)
        .then(response => {
          this.pagination = response.data
          this.filteredProducts = Object.assign({}, this.pagination.data)
          this.pagination.data.forEach(i => {
            let total = i.return_rate
            i.pct = {
              style: total <= 40 ? 'success' : total >= 80 ? 'danger' : 'warning',
              icon: total <= 40 ? 'fa fa-check mr-5' : total >= 80 ? 'fa fa-flash mr-5' : 'fa fa-warning mr-5',
              val: total
            }
            i.showChannels = true
          })
          this.loading = false
        })
        .catch(error => {
          this.$store.dispatch('checkError', error)
          this.loading = false
        })
    },
    toggle (item) {
      item.showChannels = !item.showChannels
      this.pagination.data = [...this.pagination.data]
    },
    downloadCsv () {
      let url = `?file_name_addition=${this.fileNameAddition}`
      url = url.replace(/&+$/, '')
      API.get(`inventory/downloadCsv${url}`)
        .then(response => {
          let encodedUri = encodeURIComponent(response.data)
          let link = document.createElement('a')
          link.setAttribute('href', `data:text/csv;utf-8,${encodedUri}`)
          link.setAttribute('download', 'FilteredArtikeln.csv')
          document.body.appendChild(link)
          link.click()
          this.loadingCsv = false
        }).catch(error => {
          this.$store.dispatch('checkError', error)
          this.loadingCsv = false
        })
    },
    createCsv () {
      let url = `?count=${this.pagination.per_page}&page=${this.pagination.current_page}&file_name_addition=${this.fileNameAddition}&`
      let fs = Object.keys(this.filters)
      fs.forEach(f => {
        if (f !== 'img_id') {
          if (f === 'marketplaces') {
            let channels = {}
            this.filters[f].forEach(mp => {
              channels[mp.status] = mp[mp.status]
            })
            url += `channels=${JSON.stringify(channels)}&`
          } else if (f === 'seasons') {
            url += `seasons=${JSON.stringify(this.filters.seasons)}&`
          } else {
            url += `${f}=${this.filters[f]}&`
          }
        }
      })
      url += `img_id=${this.filterNoImage ? 0 : this.filters.img_id}`
      url = url.replace(/&+$/,'')
      this.filterUrl = url
      this.selectedFilters = url.split('?')[1].split('&')
      this.loadingCsv = true
      this.prepareFilters()
      API.get(`inventory/createCsv${url}`)
        .then(response => {
          this.$store.commit('pushAlert', {type: 'success', dismiss: 4, message: 'Success!'})
          this.toggleButton = true
        })
        .catch(error => {
          this.$store.dispatch('checkError', error)
          this.loadingCsv = false
          this.toggleButton = false
        })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
select option.normal{margin:40px;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.4);background:#202227}
.is-clickable {
  cursor: pointer;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 14px !important;
  background: transparent !important;
  color: #ffffff !important;
}
.multiselect__spinner {
  background: #212228 !important;
}
.multiselect__tags {
  min-height: 40px;
  display: block;
  padding: 8px 40px 0 8px;
  border-radius: 0px !important;
  border: 1px solid rgba(255,255,255,.15);
  color: #ffffff;
  background: transparent !important;
  font-size: 14px;
}
.multiselect__content-wrapper {
  position: absolute;
  display: block;
  background: #212228;
  width: 100%;
  max-height: 240px;
  overflow: auto;
  border: 1px solid rgba(255,255,255,.15);
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 1;
  -webkit-overflow-scrolling: touch;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
  width: 20%;
}
</style>
<style scoped>
.alert.alert-message {
  position: fixed;
}
.alert-dismissible {
  z-index: 9999;
  position: fixed;
  width: 300px;
  top: 60px;
  right: 20px;
}
.loading-gif {
  padding-top: 8px;
  padding-bottom: 15px;
  width: 15%;
}
.csv-download-header {
  margin-top: 0px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Statistics/ProductStatistics.vue